const baseState = function() {
  return {
    items: [],
    paginatedItems: [],
    loading: false,
    totalItemsCount: 0,
    version: 0
  };
};

export default baseState;
